import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'devicesInfoReport',
  initialState: { subset: [], all: [], allLoaded: false, showAll: false },
  reducers: {
    setSubset(state, action) { state.subset = action.payload; },
    setAll(state, action) { state.all = action.payload; state.allLoaded = true; },
    setShowAll(state, action) { state.showAll = action.payload; },
    // Reset the "all" cache and view on (re)mount so a different user's data
    // is never shown while the fresh subset loads.
    reset(state) { state.all = []; state.allLoaded = false; state.showAll = false; },
    remove(state, action) {
      state.subset = state.subset.filter(d => d.id !== action.payload);
      state.all = state.all.filter(d => d.id !== action.payload);
    },
  }
});

export { actions as devicesInfoReportActions };
export { reducer as devicesInfoReportReducer };
